import { Box, Card, CardHeader, Divider, Stack } from '@mui/material'
import { memo } from 'react'

import { formatTicks } from '../../util/string.helpers'
import SocialStats from '../common/SocialStats'
import Button from '../shared/button/Button'
import Text from '../shared/text/Text'
import { Label } from '../shared/label'
import {
  INVITE_REFERRAL,
  shareInviteUrl
} from '../../util/inviteFriends.helpers'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'

const HowItWorks = ({
  t,
  referralMulti,
  symbol,
  onCopyReferral,
  rewardedCount,
  totalEarned,
  authId
}) => {
  const stats = [
    {
      label: t('earn-via.status-multi'),
      value: t('earn-via.multi', {
        value: referralMulti
      })
    },
    {
      label: t('referral.rewarded-invites'),
      value: formatTicks(rewardedCount)
    },
    {
      label: t('referral.earned', { symbol }),
      value: `${formatTicks(totalEarned)} ${symbol}`
    }
  ]
  return (
    <Card>
      <CardHeader
        title={t('referral.how-it-works')}
        subheader={t('referral.how-it-works-desc', { symbol })}
      />
      <Box px={3} pt={2} pb={3}>
        <Text
          label={`${t('referral.per-invited-friend')}: `}
          sx={{ mb: 0.5 }}
          variant='subtitle2'
        />
        <Stack
          direction='row'
          sx={{ mb: 2, alignItems: 'start', flexWrap: 'wrap' }}
          spacing={2}
        >
          <Label color='primary'>
            {t('referral.you-earn', {
              value: formatTicks(
                INVITE_REFERRAL.BASE_REFERRER_REWARD * referralMulti
              ),
              symbol
            })}
          </Label>
          <Label color='primary'>
            {t('referral.your-friend-earns', {
              value: formatTicks(
                INVITE_REFERRAL.BASE_REFERRED_REWARD * referralMulti
              ),
              symbol
            })}
          </Label>
        </Stack>
        <Text
          label={`${t('membership.requirements')}: `}
          sx={{ mb: 0.5 }}
          variant='subtitle2'
        />
        <Box component='ul' typography='body2' pl={2.8}>
          {['creates-account', 'staked'].map((label) => (
            <li key={label}>{t(`referral.requirement.${label}`)}</li>
          ))}
        </Box>
      </Box>
      <Divider sx={{ borderStyle: 'dashed' }} />
      <SocialStats data={stats} />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box
        p={3}
        sx={{
          gap: 2,
          flexGrow: 1,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        <Button
          label={t('referral.copy-invite-link')}
          onClick={onCopyReferral}
          variant='outlined'
        />
        <Button
          label={t('referral.share-invite-link')}
          component='a'
          href={shareInviteUrl({ authId, symbol, referralMulti })}
          {...NAVIGATION_BLANK_PARAMS}
        />
      </Box>
    </Card>
  )
}

export default memo(HowItWorks)
